module.exports = 'query GetInstance($host:String $id:ID){instance(id:$id host:$host){config cms{id token homepage}id name features}}'